import { useCallback } from 'react';
import { images } from 'common/utils';
import type { InvitationSearchOptionLabel } from '../../types';

export const useGetOptionLabelProperties = () =>
  useCallback((option: InvitationSearchOptionLabel) => {
    switch (option.type) {
      case 'community':
        return {
          description: 'Community',
          fallbackPhoto: images.default.communityProfilePhoto,
          src: option.profilePhoto,
          title: option.label,
        };
      case 'email':
        return {
          description: 'Non-registered user',
          title: option.label,
        };
      case 'user':
        return {
          description: option.email,
          src: option.profilePhoto,
          title: option.label,
        };
    }
  }, []);
